import { action, makeAutoObservable } from "mobx";

export default class FilterStore<
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  T extends Record<string, any> = Record<string, any>,
> {
  filters: T = {} as T;
  private defaultValues: Partial<T>;

  constructor(initialValues?: Partial<T>) {
    makeAutoObservable(this, {}, { deep: true });

    this.defaultValues = initialValues || {};

    if (initialValues) {
      this.filters = { ...({} as T), ...initialValues };
    }
  }

  setFilter<K extends keyof T>(key: K, value: T[K]): void {
    this.filters[key] = value;
  }

  getFilter<K extends keyof T>(key: K): T[K] {
    return this.filters[key];
  }

  removeFilter<K extends keyof T>(key: K): void {
    delete this.filters[key];
  }

  @action
  clear(): void {
    this.filters = { ...({} as T), ...this.defaultValues };
  }

  hasFilter<K extends keyof T>(key: K): boolean {
    return key in this.filters;
  }
}
